import {createSelector} from "reselect";
import {utilSelectorKeys} from "./selectorKeys";

const util_S = state => state.utils;

const creatorFn = selectorKey => {
    return createSelector(util_S, data => data[selectorKey])
};

export const utilSelectors = state => {
    const sData = {};

    utilSelectorKeys.forEach(key => {
        sData[key] = creatorFn(key)(state)
    });

    return sData;
};